import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'avatarBackgroundColor',
  pure: true // This makes it a pure pipe for better performance
})
export class AvatarBackgroundColorPipe implements PipeTransform {
  private readonly colors = [
    '#6f42c1', // Purple
    '#e83e8c', // Pink
    '#fd7e14', // Orange
    '#20c997', // Teal
    '#17a2b8', // Info
    '#6c757d', // Secondary
    '#28a745', // Success
    '#dc3545', // Danger
    '#ffc107', // Warning
    '#007bff'  // Primary
  ];

  transform(name: string): string {
    if (!name || name.length === 0) {
      return this.colors[0]; // Default color
    }
    
    const index = name.charCodeAt(0) % this.colors.length;
    return this.colors[index];
  }
}
